import { useEffect, useState } from "react";
import {
    Button,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from "reactstrap";
 
import { UpdateUserDto, UserDto } from "../types/User";
import UserService from "../Services/UserService";

interface Props {
    isOpen: boolean;
    toggle: () => void;
    user: UserDto;
    onSaved: () => void;
}

const EditUserModal = ({
    isOpen,
    toggle,
    user,
    onSaved
}: Props) => {

    const [form, setForm] = useState<UpdateUserDto>({
        name: "",
        gender: "",
        phoneNumber: "",
        isBlocked: false,
        isGroupChatAllow: true
    });

    useEffect(() => {

        if (!user) return;

        setForm({
            name: user.name,
            gender: user.gender,
            phoneNumber: user.phoneNumber ?? "",
            isBlocked: user.isBlocked ?? false,
            isGroupChatAllow: user.isGroupChatAllow ?? true
        });

    }, [user]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {

        const { name, value, type, checked } = e.target;

        setForm(prev => ({
            ...prev,
            [name]:
                type === "checkbox"
                    ? checked
                    : value
        }));

    };

    const save = async () => {

        await UserService.update(
            user.userID,
            form
        );

        toggle();

        onSaved();

    };

    return (

      <Modal
  isOpen={isOpen}
  toggle={toggle}
  centered
  size="md"

  
>
  <div>
      <ModalHeader
      toggle={toggle}
      style={{
        background: "linear-gradient(135deg,#2563eb,#4f46e5)",
        color: "#fff",
        padding: "18px 24px",
        fontWeight: 700,
         overflow: "hidden",
        fontSize: "22px",
      }}
    >
      ✏️ Edit User
    </ModalHeader>

    <ModalBody
      style={{
        padding: "30px",
      }}
    >
      <Form>

        {/* Name */}

        <FormGroup className="mb-4">
          <Label
            style={{
              fontWeight: 600,
              color: "#334155",
              marginBottom: "8px",
            }}
          >
            👤 Name
          </Label>

          <Input
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Enter Full Name"
            style={{
              borderRadius: "12px",
              height: "48px",
              border: "1px solid #dbe4f0",
              boxShadow: "none",
            }}
          />
        </FormGroup>

        {/* Gender */}

        <FormGroup className="mb-4">
          <Label
            style={{
              fontWeight: 600,
              color: "#334155",
              marginBottom: "8px",
            }}
          >
            🚻 Gender
          </Label>

          <Input
            type="select"
            name="gender"
            value={form.gender}
            onChange={handleChange}
            style={{
              borderRadius: "12px",
              height: "48px",
              border: "1px solid #dbe4f0",
              boxShadow: "none",
            }}
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </Input>
        </FormGroup>

        {/* Phone */}

        <FormGroup>
          <Label
            style={{
              fontWeight: 600,
              color: "#334155",
              marginBottom: "8px",
            }}
          >
            📱 Phone Number
          </Label>

          <Input
            name="phoneNumber"
            value={form.phoneNumber}
            onChange={handleChange}
            placeholder="Enter Phone Number"
            style={{
              borderRadius: "12px",
              height: "48px",
              border: "1px solid #dbe4f0",
              boxShadow: "none",
            }}
          />
        </FormGroup>

      </Form>
    </ModalBody>

    <ModalFooter
      style={{
        borderTop: "none",
        background: "#f8fafc",
        padding: "20px 30px",
      }}
    >
      <Button
        onClick={save}
        style={{
          background: "linear-gradient(135deg,#2563eb,#4f46e5)",
          border: "none",
          borderRadius: "10px",
          padding: "10px 28px",
          fontWeight: 600,
          boxShadow: "0 8px 20px rgba(37,99,235,.25)",
        }}
      >
        💾 Save
      </Button>

      <Button
        onClick={toggle}
        style={{
          background: "#e2e8f0",
          color: "#1e293b",
          border: "none",
          borderRadius: "10px",
          padding: "10px 28px",
          fontWeight: 600,
        }}
      >
        Cancel
      </Button>
    </ModalFooter>
  </div>
</Modal>

    );

};

export default EditUserModal;